const ProductReducer=(state,action)=>{
    

    switch (action.type) {
        case "Set_Loading":
            return{
                ...state,
                isLoading:true,
            };
        
        case "Set_Data":
    
    return {
    ...state,
    isLoading: false,
    products: action.payload,
    featureproducts: state.featureproducts.length
      ? state.featureproducts
      : action.payload.filter(p => p.featured === true)

    };
   

        case "error":
            return{
                 ...state,
                isLoading:false,
                isError:true
            };

case "Set_Categories":
  return {
    ...state,
    isLoading: false,
    categories: action.payload,
  };

case "Set_Subcategories":
  return { ...state, subcategories: action.payload };

case "Set_Items":
  return { ...state, items: action.payload };

        

          
                case "Set_Single_Loading":
                    return{
                        ...state,
                        isSingleLoading:true,
                    };
                
                case "Set_Single_Data":
                 return {
                ...state,
                isSingleLoading: false,
                singleproduct: Array.isArray(action.payload) ? action.payload[0] : action.payload,
              
            };
        
        
                case "single_error":
                    return{
                         ...state,
                        isSingleLoading:false,
                        isError:true
                    };    


                case "Set_Product_Loading":
                    return{
                        ...state,
                        isProductLoading:true,
                    };
                
                case "Set_Product_Data":
                 return {
                ...state,
                isProductLoading: false,
                singleproductInfo: Array.isArray(action.payload) ? action.payload[0] : action.payload,
              
            };
    
     
        
            case "Product_error":
                return{
                    ...state,
                    isProductLoading:false,
                    isError:true
                };   
                
            
    
        default:
            return state;
           
    }
      
};
export default ProductReducer;